// extracted by mini-css-extract-plugin
export default {"promo_wrapper":"U6","disabled":"V6","spinner":"W6","codes":"X6","item":"Y6","remove":"Z6","promo":"a7","apply":"b7"};
    if(module.hot) {
      // 1743628931063
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  